<div id="driver-wizard" class="row ">
     <div class="d-flex justify-content-between align-items-center" id="page-title">
          <h1 [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="wizard.totalSteps" [totalSteps]="wizard.totalSteps"></app-complete-bar>
                    <div class="alert alert-danger mb-0">
                         <h2 class="h3" [innerHtml]="'OrderUnsuccess' | translator: 'base'">
                              Order Unsuccessful
                         </h2>
                         <p>
                              <span [innerHtml]="'OrderUnsuccessExplanation_1' | translator: 'base'">
                                   Your order was not successful. If you would like to try ordering
                                   your record again, please
                              </span>
                              <button (click)="redirectToLoginGov()"
                                   type="button"
                                   id="loginSubmit"
                                   name="loginSubmit"
                                   class="btn btn-link alert-btn-link"
                                   [innerHtml]="'OrderUnsuccessExplanation_2' | translator: 'base'"
                                   [title]="'OrderUnsuccessExplanation_2' | translator: 'base'">
                                   Login
                              </button>
                              <span [innerHtml]="'OrderUnsuccessExplanation_3.1' | translator: 'base'">
                                   after activating your account from the message sent to the email
                                   address you provided. If you are already logged in, you can go
                                   straight to
                              </span>
                         
                              <a class="btn btn-link normal-link"
                              [href]="this.localize('##baseUrl##/driverDashboard')"
                              [innerHtml]="this.translate('OrderUnsuccessExplanation_3.2')"
                              [title]="this.translate('OrderUnsuccessExplanation_3.2')"
                              name="your-dashboard"
                              id="your-dashboard">your dashboard</a>
                              <span [innerHtml]="'OrderUnsuccessExplanation_3.3' | translator: 'base'">to try again.</span>
                         </p>
                         <p>
                              <span [innerHtml]="'OrderUnsucessCustomerService1' | translator: 'base'">
                                   If you believe you have reached this message in error, please contact the PSP Customer Support Team at
                              </span>
                              <a :title="'OrderUnsucessCustomerService2' | translator: 'base'"
                              href="tel:8776429499"
                              class="btn btn-link normal-link"
                              name="1-877-642-9499">1-877-642-9499</a>
                              <span [innerHtml]="'OrderUnsucessCustomerService3' | translator: 'base'">
                                   The PSP team is available by phone Monday through Thursday from 8 AM to 6 PM ET, and on Friday from 8 AM to 5
                                   PM ET.
                              </span>
                         </p>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard 
          *ngIf="wizard"     
          [wizardObj]="wizard"
          [activeStep]="wizard.visualProgressStep(_step)"
          pageType="driver"
          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>